<div class="title">
  <div class="coldx ">
    <h3 class="title1level" style="margin-bottom: 20px;">Aggiungi utente</h3>
  </div>
</div>
<form [formGroup]="newPersonForm">
  <div class="form-row">
    <div class="col-sm-6">
      <label for="type">Tipo Persona</label> <span class="mandatory ">*</span>
      <select (change)="updateValidators()" class="form-control" type="text" formControlName="type">
        <option [value]="null"> Seleziona tipo di persona</option>
        <option *ngFor="let type of personType "
          [disabled]="(this.formEdit) ? !(this.formData.type === type.id) : false" [ngValue]="type.id">
          {{type.name}}
        </option>
      </select>
    </div>
    <div class="col-sm-6">
      <div class="form-group" *ngIf="(this.newPersonForm.value.type == 'PHYSICAL_ENTITY') ">
        <label for="">Codice Fiscale</label> <span class="mandatory ">*</span>
        <input placeholder="Inserisci Parti Codice Fiscale (16) " formControlName="taxNumber" id="" type="text"
          class="form-control">
      </div>
      <div class="form-group" *ngIf="(this.newPersonForm.value.type == 'LEGAL_ENTITY') ">
          <!--<label for="cf">Codice Fiscale</label>
          <input (change)="updateValidators()" type="radio" formControlName="taxType" value="cf" id="cf" class="form-control">
          <label for="pi">Partita IVA</label>
          <input (change)="updateValidators()" type="radio" formControlName="taxType" value="pi" id="pi" class="form-control">-->
          <div class="col-sm-12">
            <label class='fakelabel'>Identificato da:</label> <span class="mandatory">*</span>
          </div>
          <div class="container_checkbox col-sm-12">
            <p class="singlecheckbox radiobutton inlineformelem text-center" style="padding-right: 10px;">
              <input (change)="updateValidators()" type="radio" formControlName="taxType" value="cf" id="cf" class="form-control">
              <label for="cf"></label>
              <label for="cf" class="fakelabel">Codice Fiscale</label>
            </p>
            <p class="singlecheckbox radiobutton inlineformelem text-center">
              <input (change)="updateValidators()" type="radio" formControlName="taxType" value="pi" id="pi" class="form-control">
              <label for="pi"></label>
              <label for="pi" class="fakelabel">Partita IVA</label>
            </p>
          </div>
      </div>
    </div>
  </div>
  <div class="form-row" *ngIf="(this.newPersonForm.value.type == 'PHYSICAL_ENTITY') ">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="firstName">Nome</label> <span class="mandatory ">*</span>
        <input placeholder="Inserisci Nome " formControlName="firstName" id="" type="text" class="form-control">
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="lastName-lbl">Cognome</label> <span class="mandatory ">*</span>
        <input placeholder="Inserisci Cognome" formControlName="lastName" autocomplete="family-name" id="lastName-lbl" type="text" class="form-control">
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="email-lbl">Email</label> <span class="mandatory ">*</span>
        <input placeholder="Inserisci Email " autocomplete="email" formControlName="email" id="email-lbl" type="text" class="form-control">
      </div>
    </div>
  </div>
  <div class="form-row" *ngIf="(this.newPersonForm.value.type == 'LEGAL_ENTITY') ">
    <div class="col-sm-6">
      <div class="form-group">
        <label for="name">Ragione Sociale</label> <span class="mandatory ">*</span>
        <input placeholder="Inserisci Ragione Sociale" formControlName="name" id="" type="text" class="form-control">
      </div>
    </div>
    <div class="col-sm-6">
      <div class="form-group" *ngIf="(this.newPersonForm.value.taxType == 'pi')">
        <label for="vatNumber">Partita IVA</label> <span class="mandatory ">*</span>
        <input placeholder="Inserisci Parti IVA (11) " formControlName="vatNumber" id="" type="text"
          class="form-control">
      </div>
      <div class="form-group" *ngIf="(this.newPersonForm.value.taxType == 'cf')">
        <label for="">Codice Fiscale</label> <span class="mandatory ">*</span>
        <input placeholder="Inserisci Parti Codice Fiscale (16) " formControlName="taxNumber" id="" type="text"
          class="form-control">
      </div>
    </div>
  </div>

  <div class="form-row">
    <p class="col-md-12 mandatory"><em>* Campi obbligatori</em></p>
    <div class="col-sm-5 col-xs-12"></div>
    <div class="col-sm-3 col-xs-6">
      <button type="button" (click)="formReset()" class="btn btn-outline-secondary btn-block   ">Reset</button>
    </div>
    <div *ngIf="!this.formEdit" class="col-sm-4 col-xs-6">
      <button type="submit" (click)="onAddPerson()" [disabled]="!this.newPersonForm.valid"
        class="btn btn-primary btn-block   ">Aggiungi</button>
    </div>
    <div *ngIf="this.formEdit" class="col-sm-4 col-xs-6">
      <button type="submit" (click)="onEditComplete()" [disabled]="!this.newPersonForm.valid"
        class="btn btn-primary btn-block   ">Salva </button>
    </div>

  </div>
</form>
